<!-- <ng-scrollbar class="global-container" appearance = "compact" #scrollable pointerEventsMethod="scrollbar">    -->
        
  <div class="loading-indicator">
    <mat-progress-spinner mode="indeterminate"  *ngIf="isLoading" bdColor="rgba(51,51,51,0.8)" diameter='25' strokeWidth='3'></mat-progress-spinner>
  </div>
    <!-- <h2 mat-dialog-title>Meeting Templates</h2> -->
  <mat-divider class="mat-divider"></mat-divider>
  <div class="mat-typography">
   
    <div class="row p-0 m-0" style="height: 91vh;overflow:auto;" >
      <div class="text-align-start">
        <p class="pppp">Template Categories</p>
        <button mat-raised-button actions (click) = "navigateBack()" class="button-container primary cancelbtn">
        CANCEL
      </button>
      </div>
   <div class="col-md-3 viewprtchanges">
    
    <div class="m-10">
      <mat-selection-list #template [multiple]="false" class="heightview">
        <mat-list-option [selected] (click) = "updateSelection(0)" [ngStyle] = "selectedItem === 0 ? {'color' : 'rgb(0, 0, 0)','background' : '#efefef'} : {}" [class.active]="selectedItem === 0">All Templates</mat-list-option>
        <mat-list-option *ngFor="let template of categoryType" (click) = "updateSelection(template.codeId)" [value]="template.codeId" [ngStyle] = "selectedItem === template.codeId ? {'color' : 'rgb(0, 0, 0)','background' : '#efefef'} : {}" [class.active]="selectedItem === template.codeId ? 'class-active' : ''">
          {{template.description}}
        </mat-list-option>
      </mat-selection-list> 
    </div>
   </div>
   <div class="col-md-9 tempalteview p-0">
    <div class="text-align-start">
      <mat-form-field floatLabel="auto" class="tempBtn">
        <input matInput class="body-font-size" placeholder="Search" [(ngModel)]="searchText" (input) = "searchTemplateText($event)" (keyup.enter)="searchTemplateName(this.searchText)">
        <mat-icon matSuffix id = "search-icon" (click)="searchTemplateName(this.searchText)">search</mat-icon>
      </mat-form-field>
    </div> 
    <div class="tempaltesList" [hidden]="isLoading">
        <div class="templatelistview">
          <div class="templeCount " (click) = "loadMeetingFromTemplate(null)">
             
          
              <p class="tempName m-0 titleTemp">Blank Template</p>
              <div class = "img-containerone"></div>
              <div class="selectoption">
                <p class="ViewSelect previewView m-0">Select</p> 
           
              <!-- <p class="useTemplateview" >Use Template</p> -->
          
             </div>
          </div>  
        </div>
       
      <div class="templatelistview">
        <div class="templeCount " *ngFor = "let seltemplate of templateNames">
         
         
          <p class="tempName m-0 titleTemp" (click) = "loadMeetingFromTemplate(seltemplate)" tooltip = {{seltemplate.templateName}} placement = "bottom" triggers = "hover">{{seltemplate.templateName}}</p>
          <img class = "img-containerone" (click) = "loadMeetingFromTemplate(seltemplate)" src = "assets/Dummy_1.jpg" alt = "template"/>
        <div class="selectoption">
          <p class="ViewSelect previewView m-0" (click) = "loadMeetingFromTemplate(seltemplate)" >Select</p> 
          <!-- <p class="ViewSelect previewView m-0" (click) = "meetingDetails(seltemplate.templateId, seltemplate.templateName)">Select</p>  -->
        <p class="previewViewView previewView m-0" (click) = "previewTemplate(seltemplate.templateId,seltemplate.templateName)">Preview</p> 
        <!-- <p class="useTemplateview" >Use Template</p> -->
       </div>
       
        </div> 
        <!-- <div *ngIf="templateNames?.length === 0">No records found</div> -->
       </div>
    </div> 
   </div>
    </div>
    
</div>
<!-- </ng-scrollbar> -->
